import React, { useEffect, useState } from 'react';
import ListagemItem from './ListagemItem';
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "~components/Form/components/Loader";
import { IconTop } from "~misc/icons";
import { Spinner } from '@chakra-ui/react';

const Listagem = ({ simulacoes, filter, total, loading }) => {
  const take = 3;
  const [renderedItems, setRenderedItems] = useState(take);
  const [isLoading, setIsLoading] = useState(false);

  const loadMoreItems = () => {
    setIsLoading(true);
    setTimeout(() => {
      setRenderedItems((prevRenderedItems) => prevRenderedItems + take);
      setIsLoading(false);
    }, 1100);
  };

  useEffect(() => {
    setRenderedItems(take);
  }, [filter]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <ul className='container'>
        {loading ? (
          <div className="container flex items-center justify-center pt-10">
            <Spinner size={"xl"} thickness="4px" />
          </div>
        ) : (total == 0 ? (
          <div className="text-center mt-10 text-2xl font-bold">
            Nenhum resultado encontrado!
          </div>
        ) : (
          <>
           <InfiniteScroll
              dataLength={renderedItems}
              next={loadMoreItems}
              hasMore={simulacoes && renderedItems < total}
              loader={isLoading && <Loader />}
            >
            {simulacoes && simulacoes.slice(0, renderedItems).map((item, index) => (
              <ListagemItem key={index} data={item} />
            ))}

              {!isLoading && simulacoes && renderedItems >= total && (
                <>

                  <div className="text-center mt-8 mb-8 text-xl font-bold ">
                    Fim da Listagem
                  </div>
                  <button className="voltar-ao-topo" onClick={() => scrollToTop()}>
                    <IconTop />

                  </button>
                </>
              )}
            </InfiniteScroll>
          </>
        ))}

      </ul>
    </>
  );
};

export default Listagem;
